import Ticket from './ticket';

export default Ticket;